import CIMSFormItem from 'components/CIMSFormItem'
import DescriptionFormItem from 'components/CIMSFormItem/common/DescriptionFormItem'
import NameFormItem from 'components/CIMSFormItem/common/NameFormItem'
import UserSelect from 'components/CIMSSelect/common/UserSelect'
import { HelpMessage } from 'utils/constants'

export const CreateEditFormItems: React.FC = () => {
  return (
    <>
      <NameFormItem help={HelpMessage.DesignSubmittals.Disciplines.Name} />
      <DescriptionFormItem entityName="Discipline" />
      <CIMSFormItem
        name="users"
        label="Approvers"
        help={HelpMessage.DesignSubmittals.Disciplines.Approvers}
      >
        <UserSelect mode="multiple" />
      </CIMSFormItem>
    </>
  )
}
